module.exports = __webpack_public_path__ + "img/medic_fbs_samurai_01.ea1b1b42.png";